import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import Password from './Password';

interface Props extends BaseFieldProps {
	loadChecklist?: boolean;
	description?: string;
}

const PasswordField: React.FC<Props> = props => (
	<BaseField {...props}>
		<Password
			loadChecklist={props.loadChecklist}
			description={props.description}
		/>
	</BaseField>
);

export default PasswordField;
